export default "__VITE_ASSET__CXIMGqPP__"